import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d27848b4")

_pushScopeId("data-v-d27848b4")
const _hoisted_1 = {
  key: 0,
  class: "slot-modal calendar-modal slotSaleActions"
}
const _hoisted_2 = { class: "pb10" }
const _hoisted_3 = { class: "pb10" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "slot-modal calendar-modal",
  id: "slot-modal"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { class: "stop-title" }
const _hoisted_8 = { class: "stop-title" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "gray" }
const _hoisted_11 = { class: "form-group row" }
const _hoisted_12 = { class: "col-sm-6 mb-2" }
const _hoisted_13 = { for: "product-select" }
const _hoisted_14 = { class: "col-sm-6 mb-2" }
const _hoisted_15 = { for: "product-select" }
const _hoisted_16 = {
  key: 0,
  class: "table-fixed",
  style: {"max-height":"165px"}
}
const _hoisted_17 = { class: "table table-sm mb-0" }
const _hoisted_18 = { class: "align-middle text-nowrap" }
const _hoisted_19 = { class: "align-middle text-nowrap" }
const _hoisted_20 = { class: "align-middle" }
const _hoisted_21 = { class: "align-middle text-end" }
const _hoisted_22 = {
  key: 1,
  class: "slot-modal calendar-modal",
  id: "slot-modal"
}
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = { class: "stop-title" }
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = { class: "gray" }
const _hoisted_27 = { class: "form-group row" }
const _hoisted_28 = { class: "col-12 mb-2" }
const _hoisted_29 = { for: "product-select" }
const _hoisted_30 = {
  key: 0,
  class: "table-fixed",
  style: {"max-height":"165px"}
}
const _hoisted_31 = { class: "table table-sm mb-0" }
const _hoisted_32 = { class: "align-middle text-nowrap" }
const _hoisted_33 = { class: "align-middle text-nowrap" }
const _hoisted_34 = { class: "align-middle" }
const _hoisted_35 = { class: "align-middle text-end" }
const _hoisted_36 = {
  key: 2,
  class: "slot-modal calendar-modal",
  id: "slot-modal"
}
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { class: "stop-title" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = { class: "gray" }
const _hoisted_41 = { class: "form-group row" }
const _hoisted_42 = { class: "col-sm-6 mb-2" }
const _hoisted_43 = { for: "product-select" }
const _hoisted_44 = { class: "col-sm-6 mb-2" }
const _hoisted_45 = { for: "product-select" }
const _hoisted_46 = {
  key: 0,
  class: "table-fixed",
  style: {"max-height":"165px"}
}
const _hoisted_47 = { class: "table table-sm mb-0" }
const _hoisted_48 = { class: "align-middle text-nowrap" }
const _hoisted_49 = { class: "align-middle text-nowrap" }
const _hoisted_50 = { class: "align-middle" }
const _hoisted_51 = { class: "align-middle text-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Calendar = _resolveComponent("Calendar")
  const _component_WeekdaysSelect = _resolveComponent("WeekdaysSelect")
  const _component_OverlayModal = _resolveComponent("OverlayModal")

  return (_openBlock(), _createBlock(_component_OverlayModal, {
    isOpen: _ctx.isOpen,
    "onUpdate:isOpen": _cache[13] || (_cache[13] = ($event: any) => (_ctx.isOpen = $event)),
    contentClass: "modal-limit"
  }, {
    default: _withId(() => [
      (_ctx.step == 1)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.stopCurrentSlot()))
              }, _toDisplayString(_ctx.$t('stopSaleAction.current')), 1)
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step = 2), (_ctx.stopsaleType = 2)))
              }, _toDisplayString(_ctx.$t('stopSaleAction.wholeDay')), 1)
            ]),
            _createVNode("div", null, [
              _createVNode("button", {
                type: "button",
                onClick: _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step = 2), (_ctx.stopsaleType = 3)))
              }, _toDisplayString(_ctx.$t('stopSaleAction.period')), 1)
            ])
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_4, [
            (_ctx.stopsaleType == 1)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createVNode("div", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.title')) + " ", 1),
                      _createVNode("b", null, _toDisplayString(_ctx.product.name), 1)
                    ]),
                    _createVNode("div", _hoisted_8, [
                      _createVNode("b", null, _toDisplayString(_ctx.slot.startTime) + " - " + _toDisplayString(_ctx.slot.endTime), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.description')), 1)
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode("div", _hoisted_12, [
                      _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.start_date')), 1),
                      _createVNode(_component_Calendar, {
                        modelValue: _ctx.stopSale.startDate,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.stopSale.startDate = $event)),
                        selectionMode: "single",
                        dateFormat: "dd/mm/yy",
                        required: "",
                        maxDate: (_ctx.isDate(_ctx.stopSale.endDate) ? _ctx.stopSale.endDate : _ctx.slot.repeatEndDate) || null,
                        minDate: _ctx.minDateAsToday(_ctx.slot.startDate)
                      }, null, 8, ["modelValue", "maxDate", "minDate"])
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.end_date')), 1),
                      _createVNode(_component_Calendar, {
                        modelValue: _ctx.stopSale.endDate,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.stopSale.endDate = $event)),
                        selectionMode: "single",
                        dateFormat: "dd/mm/yy",
                        required: "",
                        maxDate: _ctx.slot.repeatEndDate || null,
                        minDate: _ctx.minDateAsToday(_ctx.isDate(_ctx.stopSale.startDate) ? _ctx.stopSale.startDate : _ctx.slot.startDate)
                      }, null, 8, ["modelValue", "maxDate", "minDate"])
                    ])
                  ]),
                  _createVNode(_component_WeekdaysSelect, {
                    class: "mb-4",
                    modelValue: _ctx.stopSale.daysOfWeek,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.stopSale.daysOfWeek = $event)),
                    disabledDays: _ctx.disabledDays
                  }, null, 8, ["modelValue", "disabledDays"]),
                  (_ctx.slot.repeatStops.filter(x => !x.isChange).length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_16, [
                        _createVNode("table", _hoisted_17, [
                          _createVNode("thead", null, [
                            _createVNode("tr", null, [
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.start_date')), 1),
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.end_date')), 1),
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.weekdays')), 1),
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.revert')), 1)
                            ])
                          ]),
                          _createVNode("tbody", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slot.repeatStops.filter(x => !x.isChange), (stop) => {
                              return (_openBlock(), _createBlock("tr", {
                                key: stop.id
                              }, [
                                _createVNode("td", _hoisted_18, _toDisplayString(_ctx.getDateToTitle(stop.startDate)), 1),
                                _createVNode("td", _hoisted_19, _toDisplayString(_ctx.getDateToTitle(stop.endDate)), 1),
                                _createVNode("td", _hoisted_20, [
                                  _createVNode(_component_WeekdaysSelect, {
                                    class: "sm",
                                    modelValue: stop.daysOfWeek,
                                    "onUpdate:modelValue": ($event: any) => (stop.daysOfWeek = $event),
                                    withCheck: false,
                                    readonly: true
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createVNode("td", _hoisted_21, [
                                  _createVNode("i", {
                                    class: ["icon-f icon-history fs-18 c-blue", { disabled: _ctx.today > new Date(stop.endDate) }],
                                    onClick: ($event: any) => (_ctx.revert(stop))
                                  }, null, 10, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.stopsaleType == 2)
              ? (_openBlock(), _createBlock("div", _hoisted_22, [
                  _createVNode("div", _hoisted_23, [
                    _createVNode("div", _hoisted_24, [
                      _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.title')) + " ", 1),
                      _createVNode("b", null, _toDisplayString(_ctx.product.name), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_25, [
                    _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.description')), 1)
                  ]),
                  _createVNode("div", _hoisted_27, [
                    _createVNode("div", _hoisted_28, [
                      _createVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.start_date')), 1),
                      _createVNode(_component_Calendar, {
                        modelValue: _ctx.stopSale.startDate,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.stopSale.startDate = $event)),
                        selectionMode: "single",
                        dateFormat: "dd/mm/yy",
                        required: "",
                        maxDate: (_ctx.isDate(_ctx.stopSale.endDate) ? _ctx.stopSale.endDate : _ctx.slot.repeatEndDate) || null,
                        minDate: _ctx.minDateAsToday(_ctx.slot.startDate)
                      }, null, 8, ["modelValue", "maxDate", "minDate"])
                    ])
                  ]),
                  (_ctx.slot.repeatStops.filter(x => !x.isChange).length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_30, [
                        _createVNode("table", _hoisted_31, [
                          _createVNode("thead", null, [
                            _createVNode("tr", null, [
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.start_date')), 1),
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.end_date')), 1),
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.weekdays')), 1),
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.revert')), 1)
                            ])
                          ]),
                          _createVNode("tbody", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slot.repeatStops.filter(x => !x.isChange), (stop) => {
                              return (_openBlock(), _createBlock("tr", {
                                key: stop.id
                              }, [
                                _createVNode("td", _hoisted_32, _toDisplayString(_ctx.getDateToTitle(stop.startDate)), 1),
                                _createVNode("td", _hoisted_33, _toDisplayString(_ctx.getDateToTitle(stop.endDate)), 1),
                                _createVNode("td", _hoisted_34, [
                                  _createVNode(_component_WeekdaysSelect, {
                                    class: "sm",
                                    modelValue: stop.daysOfWeek,
                                    "onUpdate:modelValue": ($event: any) => (stop.daysOfWeek = $event),
                                    withCheck: false,
                                    readonly: true
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createVNode("td", _hoisted_35, [
                                  _createVNode("i", {
                                    class: ["icon-f icon-history fs-18 c-blue", { disabled: _ctx.today > new Date(stop.endDate) }],
                                    onClick: ($event: any) => (_ctx.revert(stop))
                                  }, null, 10, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (_ctx.stopsaleType == 3)
              ? (_openBlock(), _createBlock("div", _hoisted_36, [
                  _createVNode("div", _hoisted_37, [
                    _createVNode("div", _hoisted_38, [
                      _createTextVNode(_toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.title')) + " ", 1),
                      _createVNode("b", null, _toDisplayString(_ctx.product.name), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_39, [
                    _createVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.description')), 1)
                  ]),
                  _createVNode("div", _hoisted_41, [
                    _createVNode("div", _hoisted_42, [
                      _createVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.start_date')), 1),
                      _createVNode(_component_Calendar, {
                        modelValue: _ctx.stopSale.startDate,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.stopSale.startDate = $event)),
                        selectionMode: "single",
                        dateFormat: "dd/mm/yy",
                        required: "",
                        maxDate: (_ctx.isDate(_ctx.stopSale.endDate) ? _ctx.stopSale.endDate : _ctx.slot.repeatEndDate) || null,
                        minDate: new Date()
                      }, null, 8, ["modelValue", "maxDate", "minDate"])
                    ]),
                    _createVNode("div", _hoisted_44, [
                      _createVNode("label", _hoisted_45, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.end_date')), 1),
                      _createVNode(_component_Calendar, {
                        modelValue: _ctx.stopSale.endDate,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.stopSale.endDate = $event)),
                        selectionMode: "single",
                        dateFormat: "dd/mm/yy",
                        required: "",
                        minDate: _ctx.minDateAsToday(_ctx.isDate(_ctx.stopSale.startDate) ? _ctx.stopSale.startDate : new Date())
                      }, null, 8, ["modelValue", "minDate"])
                    ])
                  ]),
                  _createVNode(_component_WeekdaysSelect, {
                    class: "mb-4",
                    modelValue: _ctx.stopSale.daysOfWeek,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.stopSale.daysOfWeek = $event))
                  }, null, 8, ["modelValue"]),
                  (_ctx.slot.repeatStops.filter(x => !x.isChange).length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_46, [
                        _createVNode("table", _hoisted_47, [
                          _createVNode("thead", null, [
                            _createVNode("tr", null, [
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.start_date')), 1),
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.end_date')), 1),
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.weekdays')), 1),
                              _createVNode("th", null, _toDisplayString(_ctx.$t('calendar.v3.modal.stopsale.revert')), 1)
                            ])
                          ]),
                          _createVNode("tbody", null, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slot.repeatStops.filter(x => !x.isChange), (stop) => {
                              return (_openBlock(), _createBlock("tr", {
                                key: stop.id
                              }, [
                                _createVNode("td", _hoisted_48, _toDisplayString(_ctx.getDateToTitle(stop.startDate)), 1),
                                _createVNode("td", _hoisted_49, _toDisplayString(_ctx.getDateToTitle(stop.endDate)), 1),
                                _createVNode("td", _hoisted_50, [
                                  _createVNode(_component_WeekdaysSelect, {
                                    class: "sm",
                                    modelValue: stop.daysOfWeek,
                                    "onUpdate:modelValue": ($event: any) => (stop.daysOfWeek = $event),
                                    withCheck: false,
                                    readonly: true
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _createVNode("td", _hoisted_51, [
                                  _createVNode("i", {
                                    class: ["icon-f icon-history fs-18 c-blue", { disabled: _ctx.today > new Date(stop.endDate) }],
                                    onClick: ($event: any) => (_ctx.revert(stop))
                                  }, null, 10, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])),
      (_ctx.step == 2)
        ? (_openBlock(), _createBlock("button", {
            key: 2,
            class: "stopsale-button-wrapper popup-bookit-button px-5",
            onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
          }, _toDisplayString(_ctx.$t('stopSale.stopBtn')), 1))
        : _createCommentVNode("", true),
      _createVNode("button", {
        class: "close-button-wrapper popup-bookit-button px-5",
        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
      }, _toDisplayString(_ctx.$t('button.close')), 1)
    ]),
    _: 1
  }, 8, ["isOpen"]))
})